import USGSMap from 'features/integrations/features/ConnectedDevices/features/USGSMap/index.web';

const USGSFullScreen = () => <USGSMap />;

export default USGSFullScreen;
